<template>
    <div class="accordion" id="shipping-option-block-parent">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button" type="button" @click="$helper.toggleAccordion(4, true);">                          
                    {{ $helper.trans('Shipping_option_selection') }}
                </button>
            </h2>
            <div id="shipping-option-block-content" class="accordion-collapse collapse" aria-labelledby="shipping-option-block" data-parent="#shipping-option-block-parent">
                <div class="accordion-body" :class="{'pt-0': $store.state.inClientAdmin}">
                    <div class="client-admin-shipping-options-container">
                        <shipping-options-component
                            @optionSelected="$helper.toggleAccordion(5, true)"
                        ></shipping-options-component>
                        <div class="text-center" v-show="!$store.state.selectShippingService">
                            <span style="color: rgba(231, 76, 60, 0.88);">{{ $helper.trans('Select_service') }}</span>
                        </div>
                    </div>

                    <div class="link-block">
                        <button type="button" @click="$helper.toggleAccordion(3, true);" class="link link-left">{{ $helper.trans('Package_information') }}</button>
                        <button type="button" @click="$helper.toggleAccordion(5, true);" class="link link-right">{{ $helper.trans('Shipment_information') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    created: function(){
        let vueThis = this;

        vueThis.$nextTick(function(){
            setTimeout(function(){
                $('#shipping-option-block-parent').on('show.bs.collapse', function(){
                    vueThis.$store.state.awaitingActions.getSearchOptions = true; 
                });
            }, 250);
        });
    },
    methods: {
        nextStep(){    
            this.$helper.toggleAccordion(5, true);
        }  
    },
}
</script>
